/**
 * useChatSession — thin selector over the auth session to read the
 * current `user_id`. Most chat hooks need this once on render and
 * shouldn't re-implement the auth boilerplate; centralising here keeps
 * the surface DRY and gives us a single place to swap when Tauri ships
 * its own session adapter.
 */

import { getSession } from "@ando/core/auth";

export function useChatUserId(): string | null {
  const session = getSession();
  return session?.user_id ?? null;
}
